/**
 * Color palette used to represent track levels across the tracks UI (status
 * card, historical chart, etc.). Levels are colored in order — lowest ordinal
 * first — and the palette repeats if a track has more levels than colors.
 */
export const LEVEL_COLORS = [
  'var(--bui-fg-positive)',
  'var(--bui-fg-announcement)',
  'var(--bui-fg-warning)',
  'var(--bui-fg-primary)',
  'var(--bui-fg-negative)',
];

/** Muted color used for the "No Level" (ordinal 0) segment. */
export const NO_LEVEL_COLOR = 'var(--bui-bg-neutral-2)';
